import React, { useState } from 'react';
import { Loader } from '../../../../UiKit';
import { CopilotView, MerchantV1, UserV1, ValetV1 } from '../../../widgets';
import OrderTimeline from '../../../../containers/lifeline/orderTimeline';
import OrderTrackerV1 from '../../../../containers/lifeline/orderTracker';
import './LifelineOrderDetailsV1.scss';
import LifelineOrderInfoHeader from './LifelineOrderInfoHeader';
import Comments from '../../../../containers/lifeline/comments';
import { AddressV1 } from '../../../widgets/Order';
import { Repeat } from 'sushiweb/Icons';

export const LifelineOrderInfo = (props) => {
  const {
    issueSubmission,
    orderId,
    userId,
    cartId,
    isWFH,
    isTimeOut,
    lastUpdatedAt,
    mapInfo,
    refundWarning,
    orderInfo,
    comments,
    getOrderBasicInfo,
    showIssueBox,
    reloadOrder,
    openHelpSectionPopUp,
    openCallLogsModal,
    isOrderShimmer,
    getTransactionsDetails,
    setTransactionDetails,
    setIsTimeOut,
    setLastUpdatedAt,
    getCurrentTime,
    isShowCalls,
  } = props;

  const orderBasicInfo =
    orderId && orderInfo && orderInfo[orderId] ? orderInfo[orderId] : null;

  const [showAddress, setShowAddress] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [isCopilotView, setShowCopilotView] = useState(false);

  const showCopilotView = () => {
    setShowCopilotView((prev) => !prev);
  };

  const RefreshHandler = () => {
    reloadOrder(orderId);
    setIsTimeOut(false);
    setLastUpdatedAt(getCurrentTime());
  };

  const issuesBoxWidth = {
    right: isCopilotView ? '0rem' : '-40rem',
  };
  const overlayVisibility = {
    display: isCopilotView ? 'block' : 'none',
  };

  return (
    <div className='orderDetail'>
      {issueSubmission?.orderId === orderId &&
      issueSubmission?.hasSubmission ? (
        <div className='individualOrderloader'>
          <Loader />
        </div>
      ) : (
        <div className='tw-flex tw-h-full tw-rounded-[8px] tw-flex-col'>
          <div className='tw-flex-col tw-gap-6 tw-h-full tw-p-[1.6rem]'>
            {/* Order info header */}
            <div className='tw-w-full'>
              <LifelineOrderInfoHeader
                orderId={orderId}
                userId={userId}
                cartId={cartId}
                comments={comments}
                isOrderShimmer={isOrderShimmer}
                orderBasicInfo={orderBasicInfo}
                getBasicOrderInfoForGivenId={getOrderBasicInfo}
                showIssueBox={showIssueBox}
                reloadOrder={reloadOrder}
                openHelpSectionPopUp={openHelpSectionPopUp}
                openCallLogsModal={openCallLogsModal}
                getTransactionsDetails={getTransactionsDetails}
                getOrderBasicInfo={getOrderBasicInfo}
                setTransactionDetails={setTransactionDetails}
                showCopilotView={showCopilotView}
              />
            </div>

            {/* Customer, Merchant and DP */}
            <div className='tw-w-full tw-flex tw-justify-between tw-gap-4 tw-h-96'>
              <div className='tw-w-[34%] tw-h-[24rem]'>
                <UserV1
                  orderId={orderId}
                  userId={userId}
                  isWFH={isWFH}
                  refundWarning={refundWarning}
                  getOrderBasicInfo={getOrderBasicInfo}
                  orderBasicInfo={orderBasicInfo}
                />
              </div>
              <div className='tw-w-1/3 tw-h-[24rem]'>
                <MerchantV1
                  orderId={orderId}
                  userId={userId}
                  isWFH={isWFH}
                  cartId={cartId}
                  orderBasicInfo={orderBasicInfo}
                />
              </div>
              <div className='tw-w-[33%] tw-h-[24rem]'>
                <ValetV1
                  orderId={orderId}
                  userId={userId}
                  isWFH={isWFH}
                  orderBasicInfo={orderBasicInfo}
                  getOrderBasicInfo={getOrderBasicInfo}
                  isShowCalls={isShowCalls}
                />
              </div>
            </div>

            {/* Order timeline, Addresses */}
            <div className='tw-w-full tw-flex tw-justify-between tw-gap-5'>
              <div className='tw-flex tw-flex-col tw-w-[67.3333%]'>
                {orderBasicInfo?.order?.is_live && (
                  <div
                    className={` tw-w-full  ${
                      isTimeOut ? 'redRefreshAlert' : 'grayRefreshAlert'
                    }`}
                  >
                    <span>
                      {isTimeOut
                        ? `Last updated a while ago - ${lastUpdatedAt}`
                        : `Last updated at ${lastUpdatedAt} `}
                    </span>
                    <div
                      className='pointer'
                      role='button'
                      tabIndex={0}
                      css={`
                        display: flex;
                        gap: 1rem;
                      `}
                      onClick={RefreshHandler}
                    >
                      <span>
                        <Repeat size={18} color={isTimeOut ? 'red' : 'black'} />
                      </span>
                    </div>
                  </div>
                )}
                <OrderTimeline orderId={orderId} userId={userId} />
              </div>

              {/* Address */}
              <div
                className={`tw-flex tw-flex-col tw-justify-between tw-w-[32%] tw-border-solid tw-border-[1px] tw-border-grey-200 tw-rounded-xl  ${
                  orderBasicInfo?.order?.is_live
                    ? 'tw-h-[23.7rem]'
                    : 'tw-h-[21.6rem]'
                } tw-h-full tw-overflow-hidden`}
              >
                <AddressV1
                  orderId={orderId}
                  userId={userId}
                  order={orderBasicInfo}
                  isLog={true}
                  isOrderShimmer={isOrderShimmer}
                  mapInfo={mapInfo}
                  setShowAddress={setShowAddress}
                  showMap={showMap}
                  setShowMap={setShowMap}
                  showAddress={showAddress}
                />
                <OrderTrackerV1
                  orderBasicInfo={orderBasicInfo}
                  orderId={orderId}
                  userId={userId}
                  showAddress={showAddress}
                  setShowMap={setShowMap}
                  showMap={showMap}
                  setShowAddress={setShowAddress}
                />
              </div>
            </div>
          </div>

          {/* Comments Section */}
          <Comments cartId={cartId} orderId={orderId} />

          {/* Copilot view */}
          {isCopilotView && (
            <div
              className='copilotWrapper'
              style={{
                ...issuesBoxWidth,
              }}
            >
              <div className='copilotOverlay' style={overlayVisibility}></div>
              <CopilotView
                orderId={orderId}
                cartId={cartId}
                customerId={userId}
                onClose={showCopilotView}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
